import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { usePrefersReducedMotion } from "@/lib/anime/prefersReducedMotion";
import { useCinematicContext } from "@/components/landing/CinematicTransitionProvider";
import { VARIANT_BY_ROUTE } from "@/lib/landing/cinematicTransitions";
import type { Variant } from "@/lib/landing/cinematicTransitions";

export interface CinematicNavOptions {
  variant?: Variant;
  originPoint?: { x: number; y: number };
  preload?: () => Promise<unknown>;
}

export function useCinematicNavigate(): (to: string, options?: CinematicNavOptions) => void {
  const navigate = useNavigate();
  const reduced = usePrefersReducedMotion();
  const ctx = useCinematicContext();

  return useCallback(
    (to: string, options?: CinematicNavOptions) => {
      if (reduced || !ctx) {
        navigate(to);
        return;
      }

      const variant: Variant = options?.variant ?? VARIANT_BY_ROUTE[to] ?? "logo-flip";

      // Fire-and-forget preload so the chunk starts loading immediately
      options?.preload?.();

      ctx.startTransition({
        to,
        variant,
        originPoint: options?.originPoint,
        preload: options?.preload,
      });
    },
    [navigate, reduced, ctx]
  );
}
